/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSupervisorBroadcast } from './oralExamSupervisorBroadcast';

export type OralExamAggregateTimeSlotStateResponseSupervisorBroadcast = OralExamSupervisorBroadcast | null;
